module.exports = __webpack_public_path__ + "img/10-half-lg.f7da136b.jpg";